var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('section',[_c('div',{staticClass:"o-grid o-grid--no-gutter"},[_vm._m(0),_c('div',{staticClass:"o-grid__cell top-buttons"},[_c('bos-button',{on:{"click":_vm.newTeaser}},[_vm._v("Neuer Teaser")])],1)]),_c('bos-overview-table',{attrs:{"data":_vm.teasers,"columns":[
        {
          key: 'typeName',
          name: 'Typ'
        },
        {
          key: 'internalName',
          name: 'Name'
        }
      ],"deleteTitle":"Teaser löschen","deleteText":obj =>
          'Soll der Teaser <b>"' +
          obj.internalName +
          '"</b> vom Typ <b>"' +
          obj.typeName +
          '"</b> wirklich gelöscht werden?',"onEdit":_vm.editTeaser,"onDelete":_vm.deleteTeaser}})],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"o-grid__cell"},[_c('h2',[_vm._v("Teaser")])])
}]

export { render, staticRenderFns }